export const validateByMIMEType = (files: File[], acceptedFormats?: string) => {
  const acceptedFormatsArray = (acceptedFormats || '*')
    .split(',')
    .map((format) => format.trim())
    .filter(Boolean)
  const MIMERegExps = acceptedFormatsArray.map((acceptedFormat) => {
    return new RegExp(acceptedFormat.replace('*', '[^\\/,]+'))
  })

  const wrongFilesByType: File[] = []
  const acceptedFiles: File[] = []

  files.forEach((file) => {
    const fileExtension = file.name.split('.').pop() || ''
    const isWrong =
      MIMERegExps.every((regExp) => !regExp.test(file.type)) &&
      !acceptedFormatsArray.includes(`.${fileExtension}`) &&
      !acceptedFormatsArray.includes(fileExtension)
    if (isWrong) {
      wrongFilesByType.push(file)
    } else {
      acceptedFiles.push(file)
    }
  })

  return { wrongFilesByType, acceptedFiles }
}
